import styled from 'styled-components';

export const LoadingScreen = styled.div`
  min-height: 90vh;
`;
